
import React from 'react';

interface ProgressTrackProps {
  currentTime: number;
  duration: number;
  onSeek: (e: React.MouseEvent<HTMLDivElement>) => void;
  progressBarStyle?: {
    useGradient?: boolean;
    gradientFrom?: string;
    gradientTo?: string;
  };
}

export const ProgressTrack: React.FC<ProgressTrackProps> = ({
  currentTime,
  duration,
  onSeek,
  progressBarStyle
}) => {
  return (
    <div
      className="w-full h-1 bg-white/30 mb-3 rounded cursor-pointer"
      data-storyboard-target=""
      onClick={onSeek}
    >
      <div 
        className="h-full bg-white rounded"
        style={{ 
          width: `${(currentTime / duration) * 100 || 0}%`,
          ...(progressBarStyle?.useGradient ? {
            background: `linear-gradient(90deg, ${progressBarStyle.gradientFrom} 0%, ${progressBarStyle.gradientTo} 100%)`
          } : {})
        }}
      />
    </div>
  );
};
